import React from "react";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import useSnackbar from "../../hooks/useSnackbar";

import { getTransactionCreditMemoDetails, getTransactionItemFulfillment } from "../../api/transaction-type";
import { slugMap } from "../../config/slug-config";
import { Link, useParams } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Grid,
  Tabs,
  Tab,
  CircularProgress,
  Divider,
  FormControlLabel,
  FormGroup,
} from "@mui/material";
import TabPanel from "../../components/TabPanel";
import ItemsFulfillmentItems from "./item-fulfillment/items";
import ItemsFulfillmentCommunication from "./item-fulfillment/communication";
import { itemFulFillPackageTable } from "../../config/grid-column-defs";
import AgGridPaginatedTable from "../../components/AgGridPaginatedTable";
import ItemsFulfillmentRelationships from "./item-fulfillment/relationships";
import ItemsFulfillmentSystemInformation from "./item-fulfillment/systemInformation";
import ItemsFulfillmentCustom from "./item-fulfillment/custom";
import ItemsFulfillmentGlImpact from "./item-fulfillment/gl-impact";
import ItemsFulfillmentEft from "./item-fulfillment/eft";
import { CustomCheckBox } from "../../components/CheckboxComp";
import ItemFullfillmentShipping from "./item-fulfillment/shipping";

export default function TransactionTypeItemFulfilment() {
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();

  const pageDetail = slugMap[params.slug];

  // const [tableRefreshCount, setTableRefreshCount] = useState(0);
  // function refreshTable () {
  //     setTableRefreshCount(prev => prev + 1);
  // }

  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [linkingdocumentno, setlinkingdocumentno] = useState("");
  const [subTotal, setSubTotal] = useState("");
  const [discount, setDiscount] = useState("");
  const [gstHst, setGstHst] = useState("");
  const [pst, setPst] = useState("");
  const [total, setTotal] = useState("");

  /*----------------Tabs-----------------*/
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (user.token) {
      getTransactionDocCreditMemoDetailsData();
    }
  }, []);

  async function getTransactionDocCreditMemoDetailsData() {
    setLoading(true);
    try {
      const { data } = await getTransactionItemFulfillment(user.token, {
        tranid: params.docNo,
      });
      setRowData(data.data.details[0]);
      setlinkingdocumentno(data.data.linkingdocumentno);
      setSubTotal(data.data.subtotal);
      setDiscount(data.data.discount);
      setGstHst(data.data.gst_hst);
      setPst(data.data.pst);
      setTotal(data.data.total);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }

  return loading ? (
    <>
     <Typography component="h4" fontWeight={500} className="pageTitle">
        Item Fufillment
      </Typography>
      {/*Primary Information*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Primary Information
          </Typography>
          <Link to={"/transaction-type/" + params.slug}>
            <Button size="small" variant="contained" className="backBtn">
              Go Back
            </Button>
          </Link>
        </Box>
        <Box className="viewDetilsBox">
          {/* */}

          {/* ))} */}
        </Box>
      </Box>
      {/*Classification*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Classification
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <p
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </p>
            </Grid>
          </Grid>
        </Box>
      </Box>
      {/*Address Information*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Address Information
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <p
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </p>
            </Grid>
          </Grid>
        </Box>
      </Box>

      {/*Sales Information*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Sales Information
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <p
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </p>
            </Grid>
          </Grid>
        </Box>
      </Box>

      {/*Classification*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Classification
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <p
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </p>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  ) : (
    <>
      <Typography component="h4" fontWeight={500} className="pageTitle">
        Item Fufillment
      </Typography>
      <Typography component="h5" style={{ marginBottom: 5 }}>
       
          <span className="para-no" style={{ marginRight:3 }}>
            <strong>{rowData.transaction_id}</strong> {rowData.displayname}
          </span>
      
        
      </Typography>
      {/*Primary Information*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Primary Information
          </Typography>
          <Link to={"/transaction-type/" + params.slug}>
            <Button size="small" className="backBtn">
              Go Back
            </Button>
          </Link>
        </Box>
        <Box className="viewDetilsBox">
          <>
            <Grid container className="mb-2">
              <Grid item xs={12} sm={6} md={6} className="m-b-10">
              <p className="tFormlabel">REF. NO.</p>
              <p className="tFormName">{rowData.reference_number}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={6} className="m-b-10">
                <p className="tFormlabel">POSTING PERIOD</p>
                <p className="tFormName">{rowData.posting_period}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={6} className="m-b-10">
                <p className="tFormlabel">VENDOR</p>
                <p className="tFormName">{rowData.vendor_name}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={6} className="m-b-10">
                <p className="tFormlabel">MEMO</p>
                <p className="tFormName">{rowData.memo}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={6} className="m-b-10">
                <p className="tFormlabel">CREATED FROM</p>
                <p className="tFormName">{rowData.created_from}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={6} className="m-b-10">
                <p className="tFormlabel">PC/PROJECT(CUSTOM)</p>
                <p className="tFormName">{rowData.pc_project}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={6} className="m-b-10">
                <p className="tFormlabel">DATE</p>
                <p className="tFormName">{rowData.date}</p>
              </Grid>
       
              
            

           
              {/* <Grid item xs={12} sm={6} md={6} className="m-b-10">
                <p className="tFormlabel">EXCHANGE RATE</p>
                <p className="tFormName">{rowData.exchange_rate}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={6} className="m-b-10">
                <p className="tFormlabel">PURCHASE REASON </p>
                <p className="tFormName">{rowData.customer}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={6} className="m-b-10">
                <p className="tFormlabel">VENDOR</p>
                <p className="tFormName">{rowData.vendor}</p>
              </Grid>

              <Grid item xs={12} sm={6} md={6} className="m-b-10">
                <p className="tFormlabel checkAndTextAlign">
                  {rowData.requires_quote == "F" ||
                  rowData.requires_quote == null ||
                  rowData.requires_quote == "" ? (
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox disabled />}
                        label="CC REVIEWED BY HHS ADMIN"
                      />
                    </FormGroup>
                  ) : (
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox disabled checked />}
                        label="CC REVIEWED BY HHS ADMIN"
                      />
                    </FormGroup>
                  )}
                </p>
              </Grid>
              <Grid item xs={12} sm={6} md={6} className="m-b-10">
                <p className="tFormlabel">ACCOUNT</p>
                <p className="tFormName">{rowData.po}</p>
              </Grid>

              <Grid item xs={12} sm={6} md={6} className="m-b-10">
                <p className="tFormlabel">BALANCE</p>
                <p className="tFormName">{rowData.balance}</p>
              </Grid> */}
            </Grid>
          </>
        </Box>
      </Box>
   
      <Box>
        <Box
          className="viewBox "
          // sx={{ maxWidth: { xs: 320, sm: 480, md: "100%" }, bgcolor: "#fff" }}
        >
          <Tabs
            value={tabIndex}
            // onChange={handleChange}
            onChange={(e, nv) => {
              setTabIndex(nv);
            }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            className="tabs-bkg"
          >
            <Tab label="Items" />
            <Tab label="Shipping Address" />
            <Tab label="Packages"/>
            <Tab label="Relationships" />
            <Tab label="Communication" />
            <Tab label="System Information" />
           <Tab label="Custom" />
            <Tab label="Gl Impact" />
            <Tab label="EFT" />
          </Tabs>

          {/*Items*/}
          <TabPanel value={tabIndex} index={0}>
            <ItemsFulfillmentItems />
          </TabPanel>
          {/*shipping address*/}
          <TabPanel value={tabIndex} index={1}>
          {tabIndex === 1 &&    <ItemFullfillmentShipping tabIndexP={tabIndex}/>}
          </TabPanel>
     {/* packages */}
     <TabPanel value={tabIndex} index={2}>
      <Box className="viewDetilsBox">
        <Box
          sx={{
            maxWidth: { xs: 320, sm: 480, md: "100%" },
            bgcolor: "#fff",
          }}
        >
            <AgGridPaginatedTable
              //getTableRows={getTransactionShippingAddressData}
              columns={itemFulFillPackageTable}
              perPage={5}
              refreshCounter={0}
            />
        </Box>
      </Box>
          </TabPanel>
           {/* Relationship */}
          <TabPanel value={tabIndex} index={3}>
            {tabIndex === 3 && (
              <ItemsFulfillmentRelationships tabIndexP={tabIndex} />
            )}
          </TabPanel>
        {/* Communication */}
          <TabPanel value={tabIndex} index={4}>
          {tabIndex === 4 &&   <ItemsFulfillmentCommunication tabIndexP={tabIndex} />}
          </TabPanel>
    
          {/* SystemInformation */}
          <TabPanel value={tabIndex} index={5}>
            {tabIndex === 5 && <ItemsFulfillmentSystemInformation />}
          </TabPanel>
          {/* SystemInformation */}

          {/* Custom */}
          <TabPanel value={tabIndex} index={6}>
          {tabIndex === 6 && <ItemsFulfillmentCustom tabIndexP={tabIndex} />}
          </TabPanel>

          {/* GlImpact */}
          <TabPanel value={tabIndex} index={7}>
          {tabIndex === 7 &&   <ItemsFulfillmentGlImpact tabIndexP={tabIndex} />}
          </TabPanel>
          
          {/* Eft */}
          <TabPanel value={tabIndex} index={8}>
          {tabIndex === 8 &&  <ItemsFulfillmentEft tabIndexP={tabIndex} />}
          </TabPanel>
          
        </Box>
      </Box>
    </>
  );
}
